import { AES, enc } from 'crypto-js';
import CryptoJS from 'crypto-js';
import hmacSHA256 from 'crypto-js/hmac-sha256';
import Base64 from 'crypto-js/enc-base64';

const key = process.env.REACT_APP_KEY
export const encr = (value) => {
	const ciphertext = AES.encrypt(value, key).toString();
	const sanitizedText = ciphertext.replace(/\+/g, '-').replace(/\//g, '_');
	return sanitizedText;

};
export const encrKey = (value, secKey) => {
	return AES.encrypt(value, secKey);

};
export const decr = (value) => {
	let bytes = AES.decrypt(value.replace(/-/g, '+').replace(/_/g, '/'), key);
	return bytes.toString(enc.Utf8);

};
export const signature = (query_string, secKey) => {
	const hash = CryptoJS.HmacSHA256(query_string, secKey);
	const hexString = CryptoJS.enc.Base64.stringify(hash);
	console.log(hexString)
	return hexString
}

export const toBase64 = (buffer) => {
	let binary = '';
	const bytes = new Uint8Array(buffer);
	const len = bytes.byteLength;
	for (let i = 0; i < len; i++) {
		binary += String.fromCharCode(bytes[i]);
	}
	return window.btoa(binary);
};

export const computeHmacSha256 = async (key, message) => {
	// const enc = new TextEncoder();
	// const keyData = enc.encode(key);
	// const messageData = enc.encode(message);

	// const cryptoKey = await crypto.subtle.importKey(
	// 	'raw',
	// 	keyData,
	// 	{ name: 'HMAC', hash: 'SHA-256' },
	// 	false,
	// 	['sign']
	// );

	// const signature = await crypto.subtle.sign('HMAC', cryptoKey, messageData);
	// return toBase64(signature);
	try {
		const hash = hmacSHA256(key, message);
		return Base64.stringify(hash);
	} catch (error) {
		console.error("Encryption error:", error);
		return null;
	}
};